import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/pix.png'


const _hoisted_1 = { class: "input_container" }
const _hoisted_2 = { class: "right-wrapper" }
const _hoisted_3 = {
  key: 1,
  class: "right_text"
}
const _hoisted_4 = { class: "extra_amount" }
const _hoisted_5 = {
  key: 2,
  class: "right-section"
}

import { formatCurrency } from '@/utils/commonFunction'
import { ref, watch } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'inputField',
  props: {
    modelValue: {
        type: [String, Number],
        default: ''
    },
    labelText: {
        type: String,
        default: ''
    },
    isTopupVisible: {
        type: Boolean,
        default: false
    },
    giftAmount: {
        type: Number,
        default: 0
    }
},
  emits: ['update:modelValue', 'valueChanged'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const localValue = ref(props.modelValue)

watch(() => props.modelValue, (newVal) => {
    localValue.value = newVal
})

watch(localValue, (val) => {
    emit('update:modelValue', val)
    emit('valueChanged', val)
})
const onClear = () => {
    localValue.value = ''
    emit('update:modelValue', '')
    emit('valueChanged', '')
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_field, {
      modelValue: localValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
      type: "number",
      placeholder: __props.labelText,
      onClear: onClear,
      class: "custom-field"
    }, {
      "left-icon": _withCtx(() => _cache[1] || (_cache[1] = [
        _createElementVNode("div", { class: "left-section" }, [
          _createElementVNode("span", { class: "left_icon" }, "R$ ")
        ], -1)
      ])),
      "right-icon": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (localValue.value)
            ? (_openBlock(), _createBlock(_component_van_icon, {
                key: 0,
                name: "clear",
                class: "custom-clear",
                onClick: _withModifiers(onClear, ["stop"])
              }))
            : _createCommentVNode("", true),
          (props.isTopupVisible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createTextVNode(_toDisplayString(_ctx.$t('deposit.extra')) + " ", 1),
                _createElementVNode("span", _hoisted_4, "+" + _toDisplayString(_unref(formatCurrency)(__props.giftAmount)), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[2] || (_cache[2] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "PIX",
                  class: "pix-icon"
                }, null, -1)
              ])))
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "placeholder"])
  ]))
}
}

})